

<!-- Show skeleton only when headerImage is being fetched (null) -->
<div *ngIf="headerImage === null">
    <ngx-skeleton-loader [theme]="{height:'450px',width:'2000px'}"></ngx-skeleton-loader>
</div>

<!-- Dynamic banner background -->
<div *ngIf="headerImage !== null" 
     class="feasibility-section-banner w-full flex flex-col" 
     [style.background-image]="'url(' + (headerImage || 'assets/images/banners/feasibility-banner.png') + ')'"
     style="background-size: cover; background-position: center;">
    <div class="feasibility-container w-full">
        <h1 class="intro-heading">{{headerTitle}}</h1><br>
        <p class="sub-text">{{headerBody}}</p>
        <div class="w-full flex justify-center items-center">
            <app-google-search-bar class="w-full" [headerTextColor]="headerTextColor"></app-google-search-bar>
        </div>  
    </div>
</div>

<!--
<div class="flex align-items-left justify-center w-full banner bg-center bg-cover" style="background-image: url(../../../../assets/images/banners/feasibility.png); height: 800px;" *ngIf="headerImage">

    <div class="flex max:w-2/3 flex-col p-4">
        <h1 [style.color]="headerTextColor" class="font-extrabold lg:text-6xl text-4xl align-items-left">Connect with the <br> <i>speed</i> of light!</h1>
        <h2 [style.color]="headerTextColor" class="lg:text-3xl text-2xl pt-2 md:pt-6 align-items-left" >Say <i>goodbye</i> to buffering and hello to Supersonic
            <br> speeds.</h2><br>
            <h2 [style.color]="headerTextColor" class="lg:text-3xl text-2xl pt-2 md:pt-6 align-items-left" >Get ready to balst off because waiting for slow internet <br>is so last year!</h2>

        <div *ngIf="!loading" class="w-full flex-col flex items-center">
            <app-google-search-bar class="w-full" [headerTextColor]="headerTextColor"></app-google-search-bar>
        </div>
       
        
    </div>
</div>
-->
<div class="justify-center w-full bg-white my-8 flex">
    <div class="flex flex-col items-center space-y-4">
        <p class="lg:text-4xl font-bold text-center w-full text-2xl" [style.color]="bodyTextColor">
           {{learnMoreTitle}}
        </p>
        <p class="w-full lg:text-3xl text-2xl text-center" [style.color]="bodyTextColor">
           {{learnMoreBody}}
        </p>
        <div class="flex w-full justify-center  ">
            <button class="bg-accent text-black  hover:bg-secondary-600 p-6 font-bold text-xl fuse-mat-button-large" mat-flat-button
                [routerLink]="['/product-overview']">
                Learn more
            </button>
        </div>
    </div>
</div>

<div class="w-full flex justify-center">
    <div class="w-full" *ngIf="homePageBanners?.length >= 1">
        <app-swiper-packages [HomeBanner]="true" [Packages]="homePageBanners"></app-swiper-packages>
    </div>
</div>
<div class="font-bold lg:text-4xl text-3xl mt-10 flex justify-center items-center py-4">
    <p class="lg:text-4xl font-bold text-center w-full text-3xl" [style.color]="bodyTextColor">
        Reasons to join Supersonic
    </p>
</div>
<div class="lg:grid lg:grid-cols-3 lg:gap-4 justify-center max-sm:flex-col mx-6 items-start mb-18">
    <div *ngFor="let item of homePageReasons" class="reason-item">
        <div class="flex flex-row space-x-8 items-center w-full mt-12 ">
 <img [src]="item.icon.url" alt="{{item.icon.alternativeText}}" class="rounded-full p-0 m-0 w-15 h-15" loading="lazy" width="60" height="60">
            <div class="flex flex-col">
                <h2 class="text-xl md:text-2xl font-bold mb-2">{{item.title}}</h2>
                <p class="text-black text-base md:text-xl">
                   {{item.text}}
                </p>
            </div>
        </div>
    </div>
</div>
<!-- <section>
    <div class="w-full flex flex-row justify-center items-center my-10 space-x-15 rounded-lg">
        <fuse-card *ngFor="let blog of blogs" class="flex flex-col w-1/5 min-h-120 items-center justify-center space-y-2 border-[10px] border-primary-500 rounded-xl">
            <img [src]="blog.image.url"  class="bg-contain bg-center p-4" loading="lazy" width="500" height="auto">
            <h1 class="font-semibold text-center">{{blog.title}}</h1>
            <p class="font-medium text-center p-2">{{blog.shortDescription}}</p>
            <p class="text-primary py-3">{{blog.dateFormatted}}</p>
            <button (click)="viewBlog(blog.id)" class="px-4 py-2 rounded-lg text-white bg-primary-400">
                Read More..
            </button>
        </fuse-card>
    </div>
</section> -->
    <!-- <button class="fuse-mat-button-large text-lg font-bold lg:w-1/6 " mat-flat-button [color]="'accent'" routerLink="/blogs">
        View more articles
    </button> -->

<app-partners (focusInput)="focusOnSearch()"></app-partners>